import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/website/user/profile";
const apiInterestsEndpoint=API_BASE_URL_ENV() + "/website/user/interests"
const apiInterestsIDsEndPoint=API_BASE_URL_ENV() +"/website/user/interests/storage"
 const uploadRecieptApi=API_BASE_URL_ENV() +"/website/user/upload-receipt"
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getProfile = () => {
        return http.get(apiEndpoint)
    }

    getAppoinment = () => {
        return http.get(`${API_BASE_URL_ENV() + "/website/user/profile-appointments"}`)
    }
    getDeals = (params) => {
        return http.get(`${API_BASE_URL_ENV() + "/website/user/profile-deals"}`, { params })
    }
    getResales = () => {
        return http.get(`${API_BASE_URL_ENV() + "/website/user/profile-resales"}`)
    }

    updateProfile = (data) => {
        return http.post(apiEndpoint,data)
    }
    uploadReciept = (data) => {
        return http.post(uploadRecieptApi,data)
    }
   
}
